import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  badges: {},
}

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    addBadge: (state, action) => {
      state.badges = {
        ...state.badges,
        [action.payload]: true,
      }
    },
    removeBadge: (state, action) => {
      const newBadges = { ...state.badges }

      delete newBadges[action.payload]

      state.badges = newBadges
    },
  },
})

export const { addBadge, removeBadge } = sidebarSlice.actions

export default sidebarSlice.reducer
